'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var AML_STATUS_LOADED = 'aml-status:loaded';
var AML_STATUS_UPDATED = 'aml-status:updated';
var AML_STATUS_QUERY = 'aml-status:query';
var UPDATE_AML_STATUS = 'aml-status:update';
var GRACE_PERIOD_QUERY = 'grace-period:query';
var GRACE_PERIOD_UPDATED = 'grace-period:updated';

exports.AML_STATUS_LOADED = AML_STATUS_LOADED;
exports.AML_STATUS_QUERY = AML_STATUS_QUERY;
exports.AML_STATUS_UPDATED = AML_STATUS_UPDATED;
exports.GRACE_PERIOD_QUERY = GRACE_PERIOD_QUERY;
exports.GRACE_PERIOD_UPDATED = GRACE_PERIOD_UPDATED;
exports.UPDATE_AML_STATUS = UPDATE_AML_STATUS;
